import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraDataTable } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraLink } from '@mono/ui-components/ensigns';
import { SpecraEntityCell, SpecraInlineBanner, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
import { HoldingBadge, missingSuccessor, VehicleRefLink } from './vehicleUi';
const headingId = 'vehicle-holders-heading';
// specra-allow local-composite: Vehicle section composes SpecraDataTable with domain columns and callouts.
export function HoldersTable({ data, name, action }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Holders we track",
                headingId: headingId,
                action: action
            }),
            /*#__PURE__*/ _jsx(SpecraDataTable, {
                rows: data.rows,
                "aria-labelledby": headingId,
                rowKey: (r)=>r.company?.id ?? '',
                rowTestId: Testids.registryVehicle.holderRow,
                emptyTitle: "No holders tracked on this vehicle yet.",
                columns: [
                    {
                        id: 'company',
                        header: 'Company',
                        cell: (r)=>/*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(VehicleRefLink, {
                                        value: r.company,
                                        label: r.companyIsOwn ? 'Us' : r.company?.name
                                    }),
                                    r.holdingVerification && r.holdingVerification !== 'VERIFIED' && /*#__PURE__*/ _jsx(SpecraBadge, {
                                        variant: "warning",
                                        children: r.holdingVerification
                                    })
                                ]
                            })
                    },
                    {
                        id: 'this',
                        header: `On ${name}`,
                        cell: (r)=>/*#__PURE__*/ _jsx(HoldingBadge, {
                                status: r.holdingThis
                            })
                    },
                    ...data.compareVehicle ? [
                        {
                            id: 'compare',
                            header: `On ${data.compareVehicle.name}`,
                            testId: ()=>Testids.registryVehicle.compareCol,
                            cell: (r)=>/*#__PURE__*/ _jsx(HoldingBadge, {
                                    status: r.holdingCompare,
                                    danger: missingSuccessor(r)
                                })
                        }
                    ] : [],
                    {
                        id: 'pricing',
                        header: 'Pricing on file',
                        cell: (r)=>/*#__PURE__*/ _jsx(SpecraEntityCell, {
                                title: r.pricingGeneration ? /*#__PURE__*/ _jsx(VehicleRefLink, {
                                    value: r.pricingGeneration,
                                    label: r.pricingOnFileLabel
                                }) : r.pricingOnFileLabel || '—',
                                description: r.pricingOnFileDetail
                            })
                    },
                    {
                        id: 'lcats',
                        header: 'Labor categories',
                        align: 'right',
                        cell: (r)=>r.lcatCount
                    },
                    {
                        id: 'orders',
                        header: 'Task orders',
                        align: 'right',
                        cell: (r)=>r.taskOrderCount
                    }
                ]
            }),
            data.callouts.map((text, i)=>{
                const link = data.calloutLinks[i];
                const href = link && registryHref(link);
                return /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                    "data-testid": Testids.registryVehicle.callout,
                    variant: "framed",
                    tone: "warning",
                    action: href && /*#__PURE__*/ _jsx(SpecraLink, {
                        href: href,
                        renderLink: renderRouterLink,
                        children: "Open the thread →"
                    }),
                    children: text
                }, text);
            })
        ]
    });
}
